import React from "react";
import { useState, useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import Nav from "../../components/Nav";
import SideNavItem from "../../components/SideNavItem";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfilePhoto } from "../../store/AthleteActions";
import { useAxiosInstance } from "../../services/Interceptor";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faFootball,
  faSliders,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { fetchCoachDetails } from "../../store/CoachActions";

function UniversityLayout() {
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();
  const { profilePhoto } = useSelector((state) => state.athletes);
  const { coachProfileDetails } = useSelector((state) => state.coaches);
  const [profilePicture, setProfilePicture] = useState(null);

  useEffect(() => {
    const userId = authUser?.user?.id;
    const role = authUser?.user?.role;

    if (role === "university" && userId) {
      dispatch(fetchProfilePhoto(apiInstance, userId));
      dispatch(fetchCoachDetails(apiInstance, userId));
    }
  }, [dispatch, apiInstance, authUser]);

  useEffect(() => {
    if (profilePhoto) {
      setProfilePicture(profilePhoto);
    }
  }, [profilePhoto]);

  const firstName =
    coachProfileDetails?.firstName ?? authUser?.user?.firstName ?? "";
  const lastName =
    coachProfileDetails?.lastName ?? authUser?.user?.lastName ?? "";

  return (
    authUser && (
      <>
        <div className="h-screen flex flex-col">
          <div className="px-0 md:px-4 bg-[#363636]">
            <Nav />
          </div>
          <div className="flex flex-row h-full">
            <div className="w-[300px] bg-[#545353] flex-col h-full hidden sm:hidden md:hidden lg:hidden xl:block">
              {/* Profile info (image/name) */}
              <div className="w-[300px]">
                <div className="w-[100px] h-[105px] min-h-[100px] mx-auto mt-8 border-2 rounded-md border-gray-500 overflow-hidden">
                  <img
                    src={profilePicture?.fileUrl || "/default-profile-img.png"}
                    alt="profile"
                    className="object-cover h-full w-full"
                  />
                </div>
              </div>
              <p className="text-red-500 uppercase text-center text-xl mt-4 font-light">
                {firstName} {lastName}
              </p>
              <hr className="w-4/5 mx-auto mt-4" />
              {/* Links */}
              <div className="flex flex-col">
                <SideNavItem
                  route={"/university/dashboard"}
                  displayText={"Dashboard"}
                />
                <SideNavItem
                  route={"/university/athletes"}
                  displayText={"Favorite Athletes"}
                />
                <SideNavItem
                  route={"/university/combine"}
                  displayText={"Combine Results"}
                />
                <SideNavItem
                  route={"/university/account"}
                  displayText={"Account"}
                />
              </div>
            </div>
            <div className="flex-grow">
              <Outlet />
            </div>
          </div>
        </div>
        {/* Mobile bottom nov bar start */}
        <div className="fixed bottom-0 left-0 z-40 w-full h-18  bg-[#545353] block sm:block lg:block md:block xl:hidden">
          <div className="grid h-full w-full grid-cols-4 mx-auto font-medium justify-items-center">
            <Link to="/university/dashboard" className="">
              <button
                type="button"
                className="inline-flex flex-col items-center justify-center px-4 pt-4 pb-5 group hover:border-t-4 hover:border-red-500 selection:text-red-500"
              >
                <FontAwesomeIcon
                  icon={faGauge}
                  className="w-5 h-5 mb-2 text-gray-50 group-hover:text-red-500"
                />

                <span className="text-sm text-gray-50 group-hover:text-red-500">
                  Dashboard
                </span>
              </button>
            </Link>
            <Link to="/university/athletes">
              <button
                type="button"
                className="inline-flex flex-col items-center justify-center px-4 pt-4 pb-5 group hover:border-t-4 hover:border-red-500 selection:text-red-500"
              >
                <FontAwesomeIcon
                  icon={faFootball}
                  className="w-5 h-5 mb-2 text-gray-50 group-hover:text-red-500"
                />

                <span className="text-sm text-gray-50  group-hover:text-red-500">
                  Favorite Athletes
                </span>
              </button>
            </Link>
            <Link to="/university/combine">
              <button
                type="button"
                className="inline-flex flex-col items-center justify-center px-4 pt-4 pb-5 group hover:border-t-4 hover:border-red-500 selection:text-red-500"
              >
                <FontAwesomeIcon
                  icon={faSliders}
                  className="w-5 h-5 mb-2 text-gray-50  group-hover:text-red-500"
                />

                <span className="text-sm text-gray-50 group-hover:text-red-500">
                  Combine
                </span>
              </button>
            </Link>
            <Link to="/university/account">
              <button
                type="button"
                className="inline-flex flex-col items-center justify-center px-4 pt-4 pb-5 group hover:border-t-4 hover:border-red-500 selection:text-red-500"
              >
                <FontAwesomeIcon
                  icon={faUser}
                  className="w-5 h-5 mb-2 text-gray-50 group-hover:text-red-500"
                />
                <span className="text-sm text-gray-50 group-hover:text-red-500">
                  Account
                </span>
              </button>
            </Link>
          </div>
        </div>
      </>
    )
  );
}

export default UniversityLayout;
